import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

export const useIsEditorPage = () => {
  const { pathname } = useLocation()
  const isResumeEditor = useMemo(() => matchPath('resumes/:id/edit', pathname), [pathname])
  const isCoverLetterEditor = useMemo(
    () => matchPath('cover-letters/:id/edit', pathname),
    [pathname],
  )
  const isGuestResumeEditor = useMemo(() => matchPath('guest-builder', pathname), [pathname])

  const isEditPage = !!isResumeEditor || !!isCoverLetterEditor || !!isGuestResumeEditor

  return {
    isEditPage,
    isResumeEditor,
    isCoverLetterEditor,
    isGuestResumeEditor,
  }
}
